<template>
  <v-container v-if="items.length > 0">
    <v-row>
      <v-col cols="12">
        <div style="height: 25px" class="d-sm-none d-block"></div>
        <h2>Explore our contests</h2>
      </v-col>
    </v-row>
    <v-row :style="$vuetify.breakpoint.smAndDown ? 'margin: 0 -24px' : ''">
      <v-col class="pt-4" cols="12">
        <Flicking
          ref="hotEventsFlick"
          :plugins="plugins"
          @changed="handleChanged"
          :options="{
            align: 'center',
            defaultIndex: 0,
            circular: true,
            panelsPerView: -1
          }"
        >
          <div
            v-for="(item, index) in items"
            :key="index"
            class="flicking-panel"
          >
            <v-card height="99%" :href="item.attributes | attribute('actionUrl')">
              <v-img
                :src="item.mainImage | multimediapath('@/assets/default-image.png', 'size6')"
                :position="item.mainImage.coordinates"
                :height="200"
              ></v-img>
              <v-divider></v-divider>
              <v-card-title>
                {{ item.name }}
              </v-card-title>
              <v-card-text>
                {{ item.shortContent }}
              </v-card-text>
            </v-card>
          </div>
          <span slot="viewport" class="flicking-arrow-prev is-circle"></span>
          <span slot="viewport" class="flicking-arrow-next is-circle"></span>
        </Flicking>
        <div class="d-flex justify-center mt-3 delimiter-wrapper">
          <div v-for="(item, index) in items" :key="item.id" class="delimiter" :class="{ 'active': activeIndex === index }"></div>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>
<style>
@import url("../../node_modules/@egjs/vue-flicking/dist/flicking.css");
@import url("../../node_modules/@egjs/flicking-plugins/dist/arrow.css");

.flicking-arrow-next, .flicking-arrow-prev {
  display: none;
  background-color: #ef7f1a !important;
}

@media (min-width: 768px) {
  .flicking-arrow-next, .flicking-arrow-prev {
    display: block;
  }
}

.flicking-panel {
  width: 80%;
  margin-right: 10px;
}

.delimiter-wrapper {
  gap: 8px;
}

.delimiter {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #d5d5d5;
}

.delimiter.active {
  background-color: #ef7f1a;
}
</style>
<script>
import Vue from 'vue'
import { Article } from '@/model/Article'
import { Flicking } from "@egjs/vue-flicking";
import { Arrow } from "@egjs/flicking-plugins";


export default Vue.extend({
  name: 'HomeHotEvents',
  components: {
    Flicking
  },
  mounted() {
    this.$api
      .get('/events')
      .then((response) => (this.items = response.data['hydra:member']))

    this.initTimer();
  },
  data: () => ({
    items: [],
    plugins: [new Arrow()],
    activeIndex: 0,
  }),
  methods: {
    initTimer: function() {
      setInterval(() => {
        this.$refs.hotEventsFlick.next();
      }, 5000);
    },

    handleChanged: function(ev) {
      this.activeIndex = ev.index;
    }
  }
})
</script>
